var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCentrify(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 1L27 3M16 1L5 3M16 1L8 11M16 1L24 11M27 3L31 11M27 3L24 11M31 11L16 31M31 11H1M16 31L1 11M16 31L8 11M16 31L24 11M1 11L5 3M5 3L8 11",
    stroke: "#0D2144",
    strokeOpacity: 0.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCentrify);
export default __webpack_public_path__ + "static/media/Centrify.e1647bbcebcfe0c81cc6b9d9cc84149b.svg";
export { ForwardRef as ReactComponent };